$(document).ready(function(){ 
  const yearSelect = document.getElementById("year");
  const categorySelect = document.getElementById("category");
  const elements = document.querySelectorAll("a.announcement-url");
  let items = [...elements];
  
  yearSelect.addEventListener("change", function () {
    doFilter();
  });

  categorySelect.addEventListener("change", function() {
    doFilter();
  });
  
  function doFilter() {
    let yearValue = yearSelect.value;
    let categoryValue = categorySelect.value;
    
    items.forEach(item => {
      if (yearValue && categoryValue) {
        if (item.dataset.year === yearValue && item.dataset.category === categoryValue) {
          item.hidden = false;
      	} else {
          item.hidden = true;
        }
      } else if (yearValue) {
          if (item.dataset.year === yearValue) {
            item.hidden = false;
          } else {
            item.hidden = true;
          }
      } else if (categoryValue) {
          if (item.dataset.category === categoryValue) {
          	item.hidden = false;
          } else {
            item.hidden = true;
          }
      } else {
      	item.hidden = false;
      }
    });
  }
  
});
